import {mapState, mapMutations} from 'vuex';
import {isEmpty} from "../utils";
import {bookService} from "../service/book";

export const OnlineMixin = {
  data() {
    return {
      form: {
        bookDocId: '',
        bookHosId: ''
      }
    }
  },
  computed: {
    ...mapState(['userBookDoc']),
  },
  async created() {
    const {doc} = this.loginInfo;
    const {state} = this.$store;
    if (isEmpty(state.userBookDoc)) {
      const docs = await bookService.userBookDocList(doc.id);
      if (!isEmpty(docs)) {
        this.setUserBookDoc(docs);
      } else {
        this.$message.error('未关联挂号医生');
      }
    }
    this.checkCurrUserBookDoc();
  },
  async mounted() {
  
  },
  methods: {
    checkCurrUserBookDoc() {
      let {state: {currUserBookDoc, userBookDoc}} = this.$store;
      let doc = {};
      if (isEmpty(currUserBookDoc) && !isEmpty(userBookDoc)) {
        doc = this.userBookDoc.find(r => r.bookDocId);
        this.setCurrUserBookDoc(doc);
      } else {
        doc = currUserBookDoc;
      }
      this.form.bookHosId = doc.bookHosId;
      this.form.bookDocId = doc.bookDocId;
      this.form.bookDeptId = doc.bookDeptId;
    },
    ...mapMutations(['setCurrUserBookDoc', 'setUserBookDoc'])
  }
}
